import { Component } from '@angular/core';
import { PercentService } from 'src/app/shared/services/percent/percent.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent{
  totalSelectedPercent: number = 0;
  totalPercent = 100;
  remainingPercent: number = 100;

  constructor(private percentService: PercentService) {}


  ngOnInit() {
    this.percentService.totalPercent$.subscribe(total => {
      this.totalSelectedPercent = total;
      this.remainingPercent = this.totalPercent - total;
    });
  }

}
